<template>
<div id="wt-404-container">
  <div id="wt-404" class="row">
    <div class="col-md-4">
      <i class="fas fa-exclamation-circle fa-6x"></i>
    </div>

    <div class="col-md-8 ml-5" >
      <div class="row">
      <h1 class="float-left display-3 mr-4">404</h1>
      </div>
      <div class="row">
      <h5 class="pt-3">Oops! Página não encontrada!</h5>
      </div>
    </div>


  </div>
</div>

</template>

<script>
export default {
  name: "Erro404",
  components: {},

  data: function () {
    return {};
  },
  methods: {},
  watch: {},
  created() {
    this.$store.commit("setTypeLayout", 1);
  },
};
</script>

<style>
</style>

